(function () {
  // Extra card images (slides after the first, hover images) are rendered with
  // data-deferred-src/srcset so they don't all download on page load.
  function loadDeferred(img) {
    if (!img.hasAttribute('data-deferred-media')) return;
    var srcset = img.getAttribute('data-deferred-srcset');
    var src = img.getAttribute('data-deferred-src');
    img.removeAttribute('data-deferred-media');
    if (srcset) img.setAttribute('srcset', srcset);
    if (src) img.setAttribute('src', src);
  }

  function loadSlides(root, all) {
    var imgs = root.querySelectorAll('[data-card-media-slide] img[data-deferred-media]');
    for (var i = 0; i < imgs.length && (all || i < 1); i++) loadDeferred(imgs[i]);
  }

  var desktop = window.matchMedia('(min-width: 990px)');
  // When a card scrolls into view, fetch its second slide so the first swipe is instant.
  var visible =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              loadSlides(entry.target, false);
              visible.unobserve(entry.target);
            });
          },
          { rootMargin: '200px 0px' }
        )
      : null;

  function scan() {
    document.querySelectorAll('[data-card-media-slider]:not([data-deferred-scanned])').forEach(function (root) {
      root.setAttribute('data-deferred-scanned', '');
      if (!root.querySelector('img[data-deferred-media]')) return;
      if (visible) visible.observe(root);
      else loadSlides(root, true);
    });
    document.querySelectorAll('img[data-deferred-hover]').forEach(function (img) {
      img.removeAttribute('data-deferred-hover');
      if (desktop.matches) loadDeferred(img);
      else img.remove();
    });
  }

  scan();
  document.addEventListener('DOMContentLoaded', scan);
  // Grids re-rendered by filters, sorting or infinite scroll bring new cards.
  // Apps mutate the DOM constantly, so only rescan when an added node carries cards.
  var scanQueued = false;
  new MutationObserver(function (mutations) {
    if (scanQueued) return;
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType === 1 && (node.hasAttribute('data-deferred-media') || node.querySelector('[data-deferred-media]'))) {
          scanQueued = true;
          requestAnimationFrame(function () {
            scanQueued = false;
            scan();
          });
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  // Any interaction with a card's slider loads all of its slides.
  ['touchstart', 'pointerover'].forEach(function (type) {
    document.addEventListener(
      type,
      function (event) {
        var root = event.target.closest && event.target.closest('[data-card-media-slider]');
        if (root) loadSlides(root, true);
      },
      { capture: true, passive: true }
    );
  });

  function updateTrack(track) {
    var root = track.closest('[data-card-media-slider]');
    if (!root) return;
    var fill = root.querySelector('[data-card-media-progress-fill]');
    if (!fill) return;
    var slides = track.querySelectorAll('[data-card-media-slide]');
    var count = slides.length;
    if (count < 2) return;

    var maxScroll = track.scrollWidth - track.clientWidth;
    var progress = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
    var index = Math.round(progress * (count - 1));
    fill.style.transform = 'translateX(' + index * 100 + '%)';
  }

  document.addEventListener(
    'scroll',
    function (event) {
      var track = event.target;
      if (track && track.matches && track.matches('[data-card-media-track]')) {
        var root = track.closest('[data-card-media-slider]');
        if (root) loadSlides(root, true);
        updateTrack(track);
      }
    },
    { capture: true, passive: true }
  );

  var activeTrack = null;
  var startX = 0;
  var startY = 0;
  var scrollStart = 0;
  var startIndex = 0;
  var lastDx = 0;
  var direction = null;

  document.addEventListener(
    'touchstart',
    function (event) {
      var track = event.target.closest && event.target.closest('[data-card-media-track]');
      if (!track) {
        activeTrack = null;
        return;
      }
      var touch = event.touches[0];
      activeTrack = track;
      startX = touch.clientX;
      startY = touch.clientY;
      scrollStart = track.scrollLeft;
      startIndex = Math.round(scrollStart / track.clientWidth);
      lastDx = 0;
      direction = null;
    },
    { passive: true }
  );

  document.addEventListener(
    'touchmove',
    function (event) {
      if (!activeTrack) return;
      var touch = event.touches[0];
      var dx = touch.clientX - startX;
      var dy = touch.clientY - startY;

      if (direction === null) {
        direction = Math.abs(dx) >= Math.abs(dy) ? 'x' : 'y';
        if (direction === 'x') activeTrack.classList.add('is-dragging');
      }

      if (direction === 'x') {
        event.preventDefault();
        lastDx = dx;
        activeTrack.scrollLeft = scrollStart - dx;
      }
    },
    { passive: false }
  );

  document.addEventListener(
    'touchend',
    function () {
      if (!activeTrack) return;
      if (direction === 'x') {
        var slideWidth = activeTrack.clientWidth;
        var threshold = slideWidth * 0.15;
        var targetIndex = startIndex;
        if (lastDx <= -threshold) {
          targetIndex = startIndex + 1;
        } else if (lastDx >= threshold) {
          targetIndex = startIndex - 1;
        }
        var maxIndex = activeTrack.querySelectorAll('[data-card-media-slide]').length - 1;
        targetIndex = Math.max(0, Math.min(maxIndex, targetIndex));
        activeTrack.classList.remove('is-dragging');
        activeTrack.scrollTo({ left: targetIndex * slideWidth, behavior: 'smooth' });
      }
      activeTrack = null;
      direction = null;
    },
    { passive: true }
  );

  document.addEventListener('click', function (event) {
    var track = event.target.closest && event.target.closest('[data-card-media-track]');
    if (!track) return;
    var root = track.closest('[data-card-media-slider]');
    var link = root && root.querySelector('.card__heading a[href]');
    if (!link) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey) {
      window.open(link.href, '_blank');
    } else {
      window.location.href = link.href;
    }
  });
})();

(function () {
  // Card videos (snippets/card-product.liquid): on hover with a mouse, and on touch screens for the
  // (at most MAX_TOUCH) cards nearest the middle of the screen. The next MAX_PRELOAD cards coming up
  // start downloading ahead so they play as soon as they arrive; every other video has no src, so
  // phones never hold more than a few videos in memory.
  var MAX_TOUCH = 2;
  var MAX_PRELOAD = 2;
  var connection = navigator.connection;
  if ((connection && connection.saveData) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var hover = window.matchMedia('(hover: hover) and (pointer: fine)');

  function load(video) {
    if (video.getAttribute('src')) return;
    video.preload = 'auto';
    video.setAttribute('src', video.getAttribute('data-src'));
  }

  function unload(video) {
    if (!video.getAttribute('src')) return;
    video.removeAttribute('src');
    video.load();
  }

  function start(video) {
    load(video);
    var playing = video.play();
    if (playing && playing.catch) playing.catch(function () {});
  }

  function stop(video) {
    video.classList.remove('is-playing');
    video.pause();
  }

  // Swiping a card to its second photo hides the video, which sits over the first one.
  function onFirstSlide(video) {
    var track = video.parentNode.querySelector('[data-card-media-track]');
    return !track || track.scrollLeft < track.clientWidth / 2;
  }

  var visible = new Set();
  var near = new Set();
  var playingNow = new Set();

  function byDistance(videos) {
    var middle = window.innerHeight / 2;
    return videos
      .map(function (video) {
        var rect = video.getBoundingClientRect();
        return { video: video, distance: Math.abs(rect.top + rect.height / 2 - middle) };
      })
      .sort(function (a, b) {
        return a.distance - b.distance;
      })
      .map(function (entry) {
        return entry.video;
      });
  }

  function pick() {
    if (hover.matches) {
      // Mouse: hover plays; just have the cards on screen ready.
      visible.forEach(load);
      return;
    }
    var play = byDistance(Array.from(visible).filter(onFirstSlide)).slice(0, MAX_TOUCH);
    var ahead = byDistance(
      Array.from(near).filter(function (video) {
        return play.indexOf(video) === -1;
      })
    ).slice(0, MAX_PRELOAD);
    playingNow.forEach(function (video) {
      if (play.indexOf(video) === -1) {
        stop(video);
        playingNow.delete(video);
      }
    });
    document.querySelectorAll('video[data-card-video][src]').forEach(function (video) {
      if (play.indexOf(video) === -1 && ahead.indexOf(video) === -1) unload(video);
    });
    ahead.forEach(load);
    play.forEach(function (video) {
      if (!playingNow.has(video)) {
        playingNow.add(video);
        start(video);
      }
    });
  }

  var pickQueued = false;
  function queuePick() {
    if (pickQueued) return;
    pickQueued = true;
    setTimeout(function () {
      pickQueued = false;
      pick();
    }, 60);
  }

  var observer =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.intersectionRatio >= 0.4) visible.add(entry.target);
              else visible.delete(entry.target);
            });
            queuePick();
          },
          { threshold: [0, 0.4] }
        )
      : null;
  var nearObserver =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) near.add(entry.target);
              else near.delete(entry.target);
            });
            queuePick();
          },
          { rootMargin: '400px 0px' }
        )
      : null;

  function setup(video) {
    video.setAttribute('data-card-video-ready', '');
    video.addEventListener('playing', function () {
      if (onFirstSlide(video)) video.classList.add('is-playing');
    });
    if (observer) observer.observe(video);
    if (nearObserver) nearObserver.observe(video);
  }

  function scan() {
    document.querySelectorAll('video[data-card-video]:not([data-card-video-ready])').forEach(setup);
  }

  scan();
  document.addEventListener('DOMContentLoaded', scan);
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType === 1 && (node.matches('video[data-card-video]') || node.querySelector('video[data-card-video]'))) {
          requestAnimationFrame(scan);
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  window.addEventListener('scroll', queuePick, { passive: true });
  document.addEventListener(
    'scroll',
    function (event) {
      if (event.target && event.target.matches && event.target.matches('[data-card-media-track]')) {
        var video = event.target.parentNode.querySelector('video[data-card-video]');
        if (video && !onFirstSlide(video)) video.classList.remove('is-playing');
        else if (video && !video.paused) video.classList.add('is-playing');
        queuePick();
      }
    },
    { capture: true, passive: true }
  );
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      playingNow.forEach(stop);
      playingNow.clear();
    } else {
      queuePick();
    }
  });

  // Mouse: play while the pointer is over the card.
  document.addEventListener('pointerover', function (event) {
    if (!hover.matches || event.pointerType !== 'mouse') return;
    var card = event.target.closest && event.target.closest('.card-wrapper');
    var video = card && card.querySelector('video[data-card-video]');
    if (!video || video.dataset.hovering) return;
    video.dataset.hovering = '1';
    start(video);
    card.addEventListener(
      'pointerleave',
      function () {
        delete video.dataset.hovering;
        stop(video);
        video.currentTime = 0;
      },
      { once: true }
    );
  });
})();
